module.exports = __webpack_public_path__ + "img/S320.5ea99f32.jpg";